/* __next_internal_client_entry_do_not_use__ NewOrderProvider,useNewOrder auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useSearchParams } from 'next/navigation';
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/lib/firebase/firebase';
const NewOrderContext = /*#__PURE__*/ createContext(undefined);
export const NewOrderProvider = (param)=>{
    let { children, currentUserDoc, currentUser } = param;
    const [order, setOrder] = useState({
        id: '',
        vehicle: {
            vin: '',
            year: new Date().getFullYear(),
            make: '',
            model: ''
        },
        vehicle_contact_name: '',
        vehicle_contact_phone: '',
        vehicle_contact_email: '',
        dealership_name: '',
        stock_number: '',
        vehicle_address: {
            address_line_1: '',
            city: '',
            state: '',
            zip_code: ''
        },
        customer: {
            first_name: '',
            last_name: '',
            email: '',
            phone: ''
        },
        stripe_product: null,
        status: 'Draft',
        additional_notes: '',
        add_ons: [],
        checkout_session_id: '',
        customer_id: ''
    });
    const [step, setStep] = useState(1);
    const [products, setProducts] = React.useState([]);
    const [addons, setAddons] = React.useState([]);
    const searchParams = useSearchParams();
    const [referralCode, setReferralCode] = useState(null);
    useEffect(()=>{
        if (searchParams.has('c') && "object" !== 'undefined') {
            const code = searchParams.get('c');
            if (localStorage.getItem('av_referral_code')) {
                const existingCode = localStorage.getItem('av_referral_code');
                if (existingCode !== code) {
                    localStorage.setItem('av_referral_code', code);
                    setReferralCode(code);
                }
            } else {
                localStorage.setItem('av_referral_code', code);
                setReferralCode(code);
            }
        }
    }, [
        searchParams
    ]);
    useEffect(()=>{
        if ("object" !== 'undefined') {
            const code = localStorage.getItem('av_referral_code');
            if (code) {
                setReferralCode(code);
            }
        }
    }, []);
    useEffect(()=>{
        (async ()=>{
            try {
                const response = await fetch('/api/products');
                const data = await response.json();
                setProducts(data.products);
            } catch (error) {
                console.error('Error fetching products:', error);
                toast.error('Failed to load available products. Please try again later.');
            }
        })();
    }, []);
    useEffect(()=>{
        (async ()=>{
            try {
                const response = await fetch('/api/products/addons');
                const data = await response.json();
                setAddons(data.products);
            } catch (error) {
                console.error('Error fetching addons:', error);
                toast.error('Failed to load available addons. Please try again later.');
            }
        })();
    }, []);
    useEffect(()=>{
        if (!searchParams.has('order_id')) return;
        const orderId = searchParams.get('order_id');
        const unsubscribe = onSnapshot(doc(firestore, 'orders', orderId), (docSnap)=>{
            if (docSnap.exists()) {
                const orderData = docSnap.data();
                setOrder((prev)=>({
                        ...prev,
                        ...orderData,
                        id: orderId
                    }));
            }
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        searchParams
    ]);
    useEffect(()=>{
        if (currentUserDoc && currentUser) {
            setOrder((prev)=>({
                    ...prev,
                    customer: {
                        first_name: currentUserDoc.first_name,
                        last_name: currentUserDoc.last_name,
                        email: currentUser.email,
                        phone: currentUser.phoneNumber || ''
                    },
                    customer_id: currentUser.uid
                }));
        }
    }, [
        currentUserDoc,
        currentUser
    ]);
    return /*#__PURE__*/ _jsx(NewOrderContext.Provider, {
        value: {
            order,
            setOrder,
            step,
            setStep,
            products,
            setProducts,
            addons,
            setAddons,
            referralCode,
            setReferralCode
        },
        children: children
    });
};
export const useNewOrder = ()=>{
    const context = useContext(NewOrderContext);
    if (!context) {
        throw new Error('useNewOrder must be used within a NewOrderProvider');
    }
    return context;
};
